export class FilesProvider {
  tgFiles = [];

  constructor() {
    this.tgFiles = [];
  }

  addFile(file) {
    console.log(this.tgFiles);
    this.tgFiles.push(file);
  }

  getFiles() {
    return this.tgFiles;
  }

  removeFile = (index) => {
    this.tgFiles.splice(index, 1);
  };

  clearFiles() {
    this.tgFiles = [];
  }
}
